import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import TwoColumnLayout from "../layouts/TwoColumnLayout";
import { apiFetch } from "../utils/wkCommon";
import { isZh } from "../utils/language";
import { R2_PUBLIC_BASE_URL } from "../config/storage";
import FileInfoDialog from "../docs/FileInfoDialog";

export default function DocDirectPage() {
  const location = useLocation();
  const history = useHistory();

  const [docData, setDocData] = useState(null);
  const [showInfo, setShowInfo] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const documentId = params.get("document");

    if (!documentId) return;

    async function loadDoc() {
      const res = await apiFetch(
        `/api/document-files/${encodeURIComponent(documentId)}?populate=document_folder`
      );
      setDocData(res?.data || null);
    }

    loadDoc();
  }, [location.search]);

  if (!docData) {
    return (
      <TwoColumnLayout
        variant="oneColumn"
        title={isZh() ? "載入中..." : "Loading..."}
        showBack
        rightNode={<div style={{ padding: "2rem" }}>Loading...</div>}
      />
    );
  }

  const ext = docData.object_key?.split(".").pop() || "";
  const titleBase = isZh() ? docData.title_zh : docData.title_id;
  const displayTitle = `${titleBase}.${ext}`;

  const fileUrl = `${R2_PUBLIC_BASE_URL}/${docData.object_key}`;

  const previewUrl =
    docData.mime_type === "application/pdf"
      ? fileUrl
      : `https://docs.google.com/gview?url=${encodeURIComponent(
          fileUrl
        )}&embedded=true`;

  return (
    <>
    <TwoColumnLayout
      variant="oneColumn"
      title={displayTitle}
      hideLangSwitch={true}
      showBack={false}
      headerActions={
        <>
          {/* File Info */}
          <button
            className="btn-icon header-icon"
            title={isZh() ? "檔案資訊" : "File Properties"}
            onClick={() => setShowInfo(true)}
          >
            <img src="/icons/file-info.png" alt="Info" />
          </button>

          {/* Download */}
          <button
            className="btn-icon header-icon"
            title={isZh() ? "下載" : "Download"}
            onClick={async () => {
                const response = await fetch(fileUrl);
                const blob = await response.blob();

                const objectUrl = URL.createObjectURL(blob);

                const link = window.document.createElement("a");
                link.href = objectUrl;
                link.download = displayTitle;

                window.document.body.appendChild(link);
                link.click();
                window.document.body.removeChild(link);

                URL.revokeObjectURL(objectUrl);
              }}
          >
            <img src="/icons/file-download.png" alt="Download" />
          </button>
        </>
      }
      rightNode={
        <div style={{ padding: "1rem" }}>
          <iframe
            src={previewUrl}
            title="preview"
            style={{
              width: "100%",
              height: "80vh",
              border: "0",
              borderRadius: "0.5rem",
            }}
          />
        </div>
      }
    >
    </TwoColumnLayout>
    {showInfo && (
      <FileInfoDialog
        file={docData}
        onClose={() => setShowInfo(false)}
        showShareActions={false}
      />
    )}
    </>
  );
}
